// extracted by mini-css-extract-plugin
module.exports = {"blade_menu":"bladeMenu_blade_menu__3j91Q","icon":"bladeMenu_icon__BA1Ua"};